module.exports = __webpack_public_path__ + "static/3p-2-d8173eb19d2f689a91770ad65df07182.jpg";